import { ppdLagoon } from '@sde/core/src/tools/lagoon';
import { parsePayers } from './parsers';

export const getPayersRequest = async (payload) => {
  const PAYERS_DATA = { payers: [] };
  try {
    PAYERS_DATA.payers = ppdLagoon.payers;
    return parsePayers(PAYERS_DATA, payload);
  } catch (e) {
    console.log(':: getPayersRequest Error: ', e);
    return [];
  }
};
